import { IsOptional, IsString, IsInt } from 'class-validator';

export class AisGenericRequestDto {
  @IsInt()
  businessEntityId: number;

  @IsString()
  @IsOptional()
  providerCode?: string;

  @IsString()
  @IsOptional()
  institutionCode?: string;

  @IsInt()
  @IsOptional()
  id?: number;

  @IsString()
  @IsOptional()
  reference?: string;

  @IsString()
  @IsOptional()
  statuses?: string;
}
